import React, { useState } from 'react';

import {
    Button,
    Grid, IconButton, Input,
    Paper, Typography
} from '@mui/material';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SearchIcon from '@mui/icons-material/Search';

export const PageHeader = ({
    title,
    subtitle,
    search,
    onSearchClick,
    add,
    onAddClick,
    save,
    onSaveClick,
    cancel,
    onCancelClick,
    custom,
    customText,
    onCustomClick,
    disabled,
    ...props
}) => {

    const [searchText, setSearchText] = useState("");
    const searchClickHandler = () => {
        if (onSearchClick) onSearchClick(searchText);
    }

    const clearClickHandler = () => {
        setSearchText("");
        if (onSearchClick) onSearchClick(null);
    }

    const addNewClickHandler = () => {
        if (onAddClick) onAddClick();
    }

    const saveClickHandler = () => {
        if (onSaveClick) onSaveClick();
    }

    const cancelClickHandler = () => {
        if (onCancelClick) onCancelClick();
    }

    const customClickHandler = () => {
        if (onCustomClick) onCustomClick();
    }

    return (
        <>
            <Grid
                alignItems="flex-end"
                container
                justifyContent="space-between">
                <Grid item>
                    <Typography
                        component="h2"
                        variant="overline">
                        {subtitle ?? "Subtitle"}
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h5"
                        gutterBottom>
                        {title ?? "Title"}
                    </Typography>
                </Grid>
                <Grid item>
                    <Grid container>
                        {
                            custom &&
                            <Grid item>
                                <Button
                                    sx={{ marginLeft: 1 }}
                                    onClick={() => customClickHandler()}
                                    size="large"
                                    variant="contained"
                                    // disabled={disabled}
                                    >
                                    {customText}
                                </Button>
                            </Grid>
                        }
                        {cancel && !disabled &&
                            <Grid item>
                                <Button
                                    sx={{ marginLeft: 1 }}
                                    onClick={() => cancelClickHandler()}
                                    size="large"
                                    variant="contained"
                                    // disabled={disabled}
                                    >
                                    Annulla
                                </Button>
                            </Grid>
                        }
                        {add &&
                            <Grid item>
                                <Button
                                    sx={{ marginLeft: 1 }}
                                    onClick={() => addNewClickHandler()}
                                    size="large"
                                    variant="contained"
                                    disabled={disabled}>
                                    Aggiungi
                                </Button>
                            </Grid>
                        }
                        {save &&
                            <Grid item>
                                <Button
                                    sx={{ marginLeft: 1 }}
                                    onClick={() => saveClickHandler()}
                                    size="large"
                                    variant="contained"
                                    disabled={disabled}>
                                    Salva
                                </Button>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                alignItems="flex-end"
                container
                justifyItems="space-between"
                spacing={3}>
                {search &&
                    <Grid item sx={{
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        <Paper
                            sx={{
                                flexGrow: 1,
                                height: 42,
                                paddingX: 2,
                                paddingY: 0,
                                display: 'flex',
                                alignItems: 'center'
                            }}
                            elevation={1}>
                            <SearchIcon sx={{
                                marginRight: 2,
                                color: "primary.main"
                            }} />
                            <Input
                                sx={{ flexGrow: 1 }}
                                disableUnderline
                                placeholder="Cerca"
                                value={searchText}
                                disabled={disabled}
                                onChange={e => setSearchText(e.target.value)}
                                onKeyDown={e => {
                                    if (e.key == "Enter")
                                        searchClickHandler();
                                }}
                            />
                            <IconButton
                                size="small"
                                disabled={disabled}
                                onClick={() => clearClickHandler()}>
                                <CloseRoundedIcon />
                            </IconButton>
                        </Paper>
                        <Button
                            sx={{
                                backgroundColor: "primary.main",
                                marginLeft: 2,
                            }}
                            onClick={() => searchClickHandler()}
                            size="large"
                            variant="contained"
                            disabled={disabled}>
                            Cerca
                        </Button>
                    </Grid>
                }
            </Grid>
        </>
    );
}